import { createContext } from 'react';
import type { UserContext, OrganizationContext } from '../types/dashboard.types';

export interface AuthContextType {
  user: UserContext | null;
  org: OrganizationContext | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  setOrgContext: (org: OrganizationContext) => void;
  clearError: () => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
